import React, { useState, useEffect } from "react";
import {
  Button,
  InputGroupAddon,
  InputGroup,
  Col,
  Card,
  CardHeader,
  CardImg,
  CardFooter,
} from "shards-react";
import {
  flushAllPages,
  addPagetoActualDocument,
  // setEnvelopeSelectedDoc,
} from "../../../utils/redux/actions";
import { connect } from "react-redux";
import { useRequestHook } from "../../../utils/hooks/hooks";

/**
 * Export a component to render a list with element rendered in table. (e.g. atcive or done documents)
 */

const EnvelopeDocContainer = ({
  dispatch,
  docs,
  move,
  remove,
  updateTrigger,
  savedDocument,
}) => {
  const [activeDoc, setActiveDoc] = useState(null);

  useEffect(() => {
    if (docs.length > 0) {
      if (activeDoc === null) {
        setActiveDoc(docs[0].docId);
      }
    }
  }, [updateTrigger, docs]);

  const { handleRequest } = useRequestHook();

  // Click on a document to load it
  const loadDocument = (e) => {
    savedDocument.envelopeSelectedDoc = e.currentTarget.dataset["doc"];
    setActiveDoc(e.currentTarget.dataset["doc"]);
    dispatch(flushAllPages());
    handleRequest(
      "post",
      "/documents/load-selected-document",
      {
        pagesToRequest: [0],
        serviceType: null,
        documentId: savedDocument.envelopeSelectedDoc,
      },
      (response) => {
        if (response) dispatch(addPagetoActualDocument(response));
      }
    );
  };

  return docs.map(({ thumbnail_url, docId, sort }) => {
    // CSS Class for active card
    const active_class = activeDoc === docId ? "modal-sign-card-active" : "";
    return (
      <Col key={docId}>
        <Card className={"modal-sign-card " + active_class}>
          <CardHeader className="modal-sign-card-header-footer">
            <i className="fa fa-file" />
          </CardHeader>
          <CardImg
            src={thumbnail_url}
            onClick={loadDocument}
            data-doc={docId}
          />
          <CardFooter className="modal-sign-card-header-footer">
            <InputGroup className="justify-content-center modal-sign-card-inputgroup">
              <InputGroupAddon type="prepend">
                <Button
                  disabled={sort === 0 ? true : false}
                  onClick={(e) => {
                    e.preventDefault();
                    move(docId, "left");
                  }}
                >
                  <i className="fa fa-arrow-left" data-cy="move-doc-left" />
                </Button>
              </InputGroupAddon>

              <Button
                className="rounded-0"
                disabled={docs.length === 1 ? true : false}
                onClick={(e) => {
                  e.preventDefault();
                  remove(docId);
                }}
              >
                <i className="fa fa-trash" />
              </Button>

              <InputGroupAddon type="append">
                <Button
                  disabled={sort === docs.length - 1 ? true : false}
                  onClick={(e) => {
                    e.preventDefault();
                    move(docId, "right");
                  }}
                >
                  <i className="fa fa-arrow-right" data-cy="move-doc-right" />
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </CardFooter>
        </Card>
      </Col>
    );
  });
};

const mapStateToProps = ({ savedDocument }) => ({
  savedDocument,
});

export default connect(mapStateToProps)(EnvelopeDocContainer); //Export component and connect it with redux.
